import { AccessSpace } from '@upright/common/iam/access/types';
import { User } from '../../../iam/users/types';
import { CompanyIdAndName } from '../companies/types';

export interface DataSourcePublic {
  id: string;
  name: string;
  priority?: number;
}

export interface DataSource extends DataSourcePublic {
  accessSpace: AccessSpace;
  visibility?: DataSourceVisibility;
  description?: string;
  comment?: string;
  createdAt: string;
  updatedAt: string;
  createdBy: number;
  updatedBy: number;
  createdByUser?: User;
  updatedByUser?: User;
  coverage?: DataSourceCoverage;
}

export interface DataSourceWithCoverage extends DataSource {
  coverage: DataSourceCoverage;
}

// Used only in UI forms
export type PartialDataSource = Partial<DataSource>;

export interface DataSourceCoverage {
  revenues: number;
  employeeCounts: number;
  incomes: number;
  companies?: CompanyIdAndName[];
}

export enum DataSourceVisibility {
  PUBLIC = 'public',
  CLIENT_ONLY = 'client_only',
  TEAM_ONLY = 'team_only',
}

export enum SpecialDataSourceId {
  WIKIDATA = 'wikidata',
  INSIDEVIEW = 'insideview',
  UPRIGHT = 'upright',
  SEC = 'sec',
  FISE = 'fi-se',
  FINNHUB = 'finnhub',
  PITCHBOOK = 'pitchbook',
}

export const massImportedGroupSources = [SpecialDataSourceId.SEC, SpecialDataSourceId.FISE];
export function isMassImportedGroup(source: string) {
  return massImportedGroupSources.includes(source as SpecialDataSourceId);
}

export const MAX_COMPANIES_TO_SHOW_FOR_DATA_SOURCE = 2000;

export type DataSourceNameById = { [id: string]: string };
